import { Box, Button, Grid, TextField, InputLabel } from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Location
        </InputLabel>
        <TextField
          variant="outlined"
          name="location"
          value={filterData.location}
          onChange={handleChangeFilter("location")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
